import React from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  path: string;
  isFullUrl?: boolean;
}

export const PdfViwer: React.FC<Props> = ({
  open,
  onClose,
  path,
  isFullUrl,
}) => {
  const fileUrl = isFullUrl ? path : `${process.env.REACT_APP_cmsUrl}${path}`;
  if (!open) return null;

  return (
    <div className="pdf-overlay" onClick={onClose}>
      <div className="pdf-wrapper">
        {/* Close button */}
        <button
          type="button"
          className="close pdf-close"
          aria-label="Close"
          onClick={onClose}
        >
          <span aria-hidden="true">&times;</span>
        </button>

        <div className="pdf-modal">
          <iframe
            src={fileUrl}
            title="PDF Preview"
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        </div>
      </div>
    </div>
  );
};
